
import React from "react";
import ImageCropModal from "components/atoms/ImageCropModal/ImageCropModal";

function StoryImageUpload() {
  return (
    <div className="add-people-content">
      <ImageCropModal />
    </div>
  );
}

export default StoryImageUpload;
